import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { useBackendAuthenticated } from "@/hooks/useBackendAuthenticated";

const AuditLogEntrySchema = z.object({
  id: z.string(),
  action: z.string(),
  resourceType: z.string().nullable(),
  resourceId: z.string().nullable(),
  metadata: z.record(z.unknown()).nullable().optional(),
  createdAt: z.string(),
  userId: z.string().nullable(),
  userName: z.string().nullable(),
  userEmail: z.string().nullable(),
});

const AuditLogsResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(AuditLogEntrySchema),
  total: z.number(),
  totalTranscriptionSeconds: z.number(),
});

export function useAuditLogs({
  page,
  limit = 20,
}: {
  page: number;
  limit?: number;
}) {
  const backend = useBackendAuthenticated();
  return useQuery({
    queryKey: ["audit-logs", page],
    queryFn: async () => {
      const json = await backend({
        method: "GET",
        url: "/api/v1/audit-logs",
        params: { page, limit },
      });
      return AuditLogsResponseSchema.parse(json);
    },
  });
}
